import {
  IsInitialLoadReadyActionTypes,
  isInitialLoadReadyConstant,
} from 'actions/user/isInitialLoadReady'

export const isInitialLoadReadyInitialState = false

export default (
  state: boolean = isInitialLoadReadyInitialState,
  action: IsInitialLoadReadyActionTypes
) => {
  switch (action.type) {
    case isInitialLoadReadyConstant.SET_IS_INITIAL_LOAD_READY:
      return action.payload

    default:
      return state
  }
}
